"use strict";

module.exports = require("./dist/src/gatsby-browser.js");
